<script>
    // Stores 
    import { textSite } from '../store.js';    

    // Componentes
    import { link } from "svelte-routing";
    import PageHeader from './../components/PageHeader.svelte';

    // Code
    let titlePage = 'Garantias Locatícias';    
    
    let itens = [{}];

    let garantias = [
        {
            name: 'CredPago',
            icon: `<i class="fas fa-credit-card"></i>`,
            text: `a modalidade que mais tem crescido. Basta ter um cartão de crédito, valor de no mínimo 1x o valor locatício (aluguel, condomínio, IPTU e luz). Caso aprove, é cobrado mensalmente 10% do valor locatício, e uma única e exclusiva vez uma taxa de R$180.00. CredPago é renovado anualmente.`,
        },
        {
            name: 'Fiador',
            icon: `<i class="fas fa-user-shield"></i>`,
            text: `nesta clássica modalidade, é necessário 01 fiador com 02 imóveis; ou 02 fiadores com 01 imóvel cada. Lembre-se: os imóveis devem ser no Estado do RS.`,
        },
        {
            name: 'Seguro Fiança',
            icon: `<i class="fas fa-shield-check"></i>`,
            text: `Cia Porto Seguro. Neste caso, paga-se o valor do seguro, que é em torno de 2 vezes o valor do aluguel + encargos. O valor é parcelado em até 6 vezes no cheque. O seguro é renovado anualmente. `
        },
        {
            name: 'Titulo de Capitalização',
            icon: `<i class="fas fa-money-check-alt"></i>`,
            text: `um investimento e uma garantia. Título da Sul América. É pago um boleto (12x o valor do aluguel), exemplo: em um aluguel de R$1.000,00 o valor do Título será de R$ 12.000,00. Quando da desocupação do imóvel, o valor retorna corrigido, após liberação da locação.`,
        },
        {
            name: 'Aluguel sem fiador',
            icon: `<i class="fas fa-key"></i>`,
            text: `alguns imóveis comportam o aluguel livre de garantias. Neste caso, o cadastro dos candidatos é analisado em conjunto com o proprietário do imóvel, de maneira que os riscos do negócio fiquem totalmente claros. `,
        },
    ];
</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>
    <div class="container">
        <p>Formas de garantia ao contrato de Locação:</p>
        <div class="box-itens-icon">
            {#each garantias as garantia}
                <div class="item">
                    <div class="icon">
                        {@html garantia.icon}
                    </div>
                    <div class="infos">
                        <h2 class="title">{garantia.name}</h2>
                        <p>{@html garantia.text}</p>
                    </div>
                </div>
            {/each}
        </div>
        <div class="button text-center mt-40">        
            <a href="/documentacao-necessaria" use:link replace title="Confira a documentação necessária para locação" class="btn btn-secondary">Confira a documentação necessária para locação <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
        </div>
    </div>
</section>